import { render, staticRenderFns } from "./MorphologicalSegmentation.vue?vue&type=template&id=7df2a6f0&scoped=true"
import script from "./MorphologicalSegmentation.vue?vue&type=script&lang=js"
export * from "./MorphologicalSegmentation.vue?vue&type=script&lang=js"
import style0 from "./MorphologicalSegmentation.vue?vue&type=style&index=0&id=7df2a6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df2a6f0",
  null
  
)

export default component.exports